import token from 'styled-token';
import { deepMap } from '../../util/deepMap';
import { deepRename } from '../../util/deepRename';
import { mediaBreakpointMixin } from '../mediaBreakpointMixin';
var UNIT_ORPHANS = ['animationDuration', 'flexGrow', 'fontWeight', 'gridColumn', 'gridRow', 'transitionDuration', 'opacity', 'order', 'zIndex'];
var UNIT_DEFAULTS = {
  animationDuration: 's',
  transitionDuration: 's'
};
var getTransformedToken = function getTransformedToken(_ref) {
  var styleVal = _ref.styleVal,
    props = _ref.props,
    attr = _ref.attr;
  var transformToken = function transformToken(val) {
    return val.split(' ').map(function (prop) {
      if (!prop.includes('$')) {
        return prop;
      }
      return prop.split(',').map(function (p) {
        var _UNIT_DEFAULTS$attr;
        if (!p.includes('$')) {
          return p;
        }
        var variant = p.replace(/\\s|/g, '').replace(/^\$/g, '').replace(/(\$.*?)/g, '.').replace(/[()]/g, '')
        // Handles tokens within `calc()`, ie `calc($spacing.sm - 10px)`
        .replace(/^calc\./g, '');
        variant = token(variant)(props);
        variant = typeof variant === 'number' && !UNIT_ORPHANS.includes(attr) ? variant + "px" : "" + variant + ((_UNIT_DEFAULTS$attr = UNIT_DEFAULTS[attr]) !== null && _UNIT_DEFAULTS$attr !== void 0 ? _UNIT_DEFAULTS$attr : '');

        // add back any parentheses
        if (p.endsWith(')')) {
          variant = variant + ")";
        }
        if (p.startsWith('(')) {
          variant = "(" + variant;
        }
        if (p.startsWith('calc(')) {
          variant = "calc(" + variant;
        }
        return variant;
      }).join(',');
    }).join(' ');
  };
  if (typeof styleVal === 'string') {
    return transformToken(styleVal);
  }
  return styleVal;
};

/** @class BoxMixin */
/** @method */
export var BoxMixin = function BoxMixin(props) {
  if (!props.sx) {
    return {};
  }
  var sx = props.sx;
  var getMQText = function getMQText(mq) {
    if (!mq.includes('$')) {
      return mq;
    }
    var breakpoint = mq.match(/(\$)\w+/g)[0].replace(/^\$/g, '');
    return "@media " + mediaBreakpointMixin(breakpoint)(props);
  };
  var styles = deepRename(sx, getMQText);
  return deepMap(styles, function (val, key) {
    if (Array.isArray(val)) {
      return val.map(function (v) {
        return typeof v !== 'number' ? getTransformedToken({
          styleVal: v,
          attr: key,
          props: props
        }) : v;
      }).map(function (v) {
        return "\"" + v + "\"";
      }).join(' ');
    }
    return typeof val !== 'number' ? getTransformedToken({
      styleVal: val,
      attr: key,
      props: props
    }) : val;
  });
};